import { render } from "./Badge3.vue?vue&type=template&id=6fd2faaf&scoped=true"
import script from "./Badge3.vue?vue&type=script&lang=js"
export * from "./Badge3.vue?vue&type=script&lang=js"

import "./Badge3.vue?vue&type=style&index=0&id=6fd2faaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd2faaf"]])

export default __exports__